import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Subscriber } from '../../models/shared/subscriber-model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class SubscriberService { 
  private serviceName = 'api/Subscribers'
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }

  AddSubscriber(Subscribermodel: Subscriber): void {
    this.http
      .post(`${this.serviceName}`, Subscribermodel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/Subscribers"]);
      });
  }
  updateSubscriber(Subscribermodel: Subscriber): void {
    //Todo
    this.http
      .put(`${this.serviceName}`, Subscribermodel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/Subscribers"]);
      });
  }
  deleteSubscriber(id: string) {
    return this.http.delete(`${this.serviceName}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
  }
  getSubscribers() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getSubscriber(id: string) {
    return this.http.get(`${this.serviceName}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  exportSubscribers() {
    return this.http.post(`${this.serviceName}/ExportSubscribers`, null, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/others/subscriber.service.ts